module.exports = __webpack_public_path__ + "static/media/12x12-13.6914cd33.png";